import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const SingleCard = styled(Flex)`
  background: ${props => (props.background ? props.background : '#FFFFFF')};
  padding: ${props => (props.padding ? props.padding : 0)};
  border-radius: 10px;
  border: 2px solid ${props => props.borderColor || '#BFBFBF'};
  min-width: 12em;
  width: ${props => props.width};
  height: ${props => (props.height ? props.height : 'auto')};
  cursor: pointer;
  transition: border-color 0.3s ease, background-color 0.3s ease, color 0.3s ease; 
    transform 0.2s ease;
  justify-content: space-around;
`

export const CardValue = styled.p`
  margin: 0;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: ${props => props.valueColor || COLORS.GREY_T_20};
`

export const CardText = styled.p`
  margin-top: 10px;
  margin-bottom: 4px;
  font-style: normal;
  font-family: 'Plus Jakarta Sans';
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  color: ${props => (props.isSelected ? '#000000' : '#434343')};
`

export const IconTextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const TextWrapper = styled.div`
  font-weight: bold;
  font-size: 16px;
`
